import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input, Select } from 'antd'
import { CUSTOMER_STATUS_OPTIONS } from 'constants'

const CustomerSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [baseForm] = Form.useForm()

  // [COMPUTED_PROPERTIES]
  const usedForm = form || baseForm

  // [HANDLERS]
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Customer')}
        </Title>
      )}
      <Form.Item
        label={t('Name')}
        name={[...group, 'name']}
        rules={[
          {
            required: true,
            message: t('Please enter your customer name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('customer name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your customer name')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name={[...group, 'email']}
        rules={[
          {
            required: true,
            message: t('Please enter your customer email!')
          },
          { max: MAX_LENGTH_FIELD, message: t('customer email is too long!') }
        ]}>
        <Input placeholder={t('Please enter your customer email')} />
      </Form.Item>
      <Form.Item
        label={t('Status')}
        name={[...group, 'status']}
        rules={[
          {
            required: false,
            message: t('Please enter your customer status!')
          }
        ]}>
        <Select
          placeholder={t('Please enter your customer status')}
          options={CUSTOMER_STATUS_OPTIONS.map((o) => ({
            ...o,
            label: t(o.label)
          }))}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Customer')}
        </Title>
      )}
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          {
            required: true,
            message: t('Please enter your customer name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('customer name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your customer name')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name="email"
        rules={[
          {
            required: true,
            message: t('Please enter your customer email!')
          },
          { max: MAX_LENGTH_FIELD, message: t('customer email is too long!') }
        ]}>
        <Input placeholder={t('Please enter your customer email')} />
      </Form.Item>
      <Form.Item
        label={t('Status')}
        name="status"
        rules={[
          {
            required: false,
            message: t('Please enter your customer status!')
          }
        ]}>
        <Select
          placeholder={t('Please enter your customer status')}
          options={CUSTOMER_STATUS_OPTIONS.map((o) => ({
            ...o,
            label: t(o.label)
          }))}
        />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

CustomerSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default CustomerSimpleForm
